import { render, staticRenderFns } from "./msgCentter.vue?vue&type=template&id=406b5d40&scoped=true&"
import script from "./msgCentter.vue?vue&type=script&lang=js&"
export * from "./msgCentter.vue?vue&type=script&lang=js&"
import style0 from "./msgCentter.vue?vue&type=style&index=0&id=406b5d40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b5d40",
  null
  
)

export default component.exports